export const availability = {
  forSale: {
    originalId: '61095150',
  },
  sold: {
    originalId: '61095151',
  },
}
